<template>
  <div class="index">
    <div class="chart-box">
      <div class="container">
        <el-row>
          <!-- <el-col :span="12" style="display:flex;justify-content: left;">
          <img class="logo" src="../assets/images/szlogo.png" alt />
          <span data-v-47ed053c="" class="logoHos">宁波大学医学院附属医院</span>
        </el-col> -->
          <el-col :span="12">
            <!-- 医院logo -->
            <div class="top-box-logo"></div>
            <h1 style="margin-top:-32px">文献资源数据库</h1>
          </el-col>
          <el-col :span="12" class="top-right">
            <span v-if="loginName">
              欢迎
              <router-link to="/center/index">{{ loginName }}</router-link>
              <el-button type="danger" class="login" plain @click="logout"
                >退出</el-button
              >
            </span>
            <!-- <el-button
              v-else
              type="danger"
              class="login"
              plain
              @click="dialogVisible = true"
              >用户登录</el-button
            > -->
          </el-col>
        </el-row>
        <el-dialog
          title="登录"
          :visible.sync="dialogVisible"
          width="30%"
          @close="resetForm('loginForm')"
          :destroy-on-close="destroy"
        >
          <el-form
            :label-position="labelPosition"
            :rules="loginRules"
            ref="loginForm"
            label-width="80px"
            :model="loginForm"
          >
            <el-form-item label="用户名" prop="loginName">
              <el-input v-model="loginForm.loginName"></el-input>
            </el-form-item>
            <el-form-item label="密码" prop="password">
              <el-input type="password" v-model="loginForm.password"></el-input>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="login('loginForm')"
              >确 定</el-button
            >
          </span>
        </el-dialog>
      </div>
    </div>
    <div class="nav">
      <el-menu
        :default-active="activeIndex"
        class="el-menu-demo box top-container"
        mode="horizontal"
        text-color="#C0232B"
        active-text-color="#000000"
        router
      >
        <el-menu-item index="/" route="/home">文献资源</el-menu-item>
        <el-menu-item index="/results" route="/results">全部成果</el-menu-item>
        <el-menu-item index="/patent" route="/patent">中心专利</el-menu-item>
        <el-menu-item index="/talent" route="/talent">学者档案</el-menu-item>
        <el-menu-item index="/subject" route="/subject">组织机构</el-menu-item>
        <el-menu-item index="/analysis" route="/analysis"
          >论文分析</el-menu-item
        >
        <!-- <el-menu-item
        :disabled="name != 'admin'"
        index="/visualization"
        route="/visualization"
        >可视化分析</el-menu-item
      > -->
        <el-menu-item index="7"
          ><a target="_blank" href="http://115.29.212.238:8083/"
            >JIF查询</a
          ></el-menu-item
        >
      </el-menu>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "top",
  data() {
    return {
      activeIndex: this.$route.path,
      isRouter: true,
      name: document.cookie ? document.cookie.split("loginName=")[1] : "",
      dialogVisible: false,
      labelPosition: "right",
      destroy: true,
      loginForm: {
        loginName: "",
        password: "",
      },
      loginRules: {
        loginName: [
          { required: true, message: "请输入账号名称", trigger: "blur" },
          { min: 3, message: "长度至少为 3 个字符", trigger: "blur" },
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { min: 3, message: "长度至少为 3 个字符", trigger: "blur" },
        ],
      },
      loginName: localStorage.getItem('sname')||'',
      userId: "",
    };
  },
  updated() {
    this.name = document.cookie ? document.cookie.split("loginName=")[1] : "";
    // alert( this.name)
  },
  methods: {
    login(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let currentThis = this;
          axios({
            method: "post",
            url:
              "/api/web/login?loginName=" +
              this.loginForm.loginName +
              "&password=" +
              this.loginForm.password,
            //data:this.loginForm
          })
            .then(function (response) {
              console.log(response);
              if (response.data.code == "8001") {
                currentThis.dialogVisible = false;
                currentThis.$cookies.set("rtnVal", response.data.data);
                currentThis.$cookies.set(
                  "loginName",
                  currentThis.loginForm.loginName
                );
                currentThis.loginName = currentThis.loginForm.loginName;
                location.reload();
              } else {
                alert(response.data.msg);
              }
            })
            .catch(function (thrown) {
              console.log(thrown);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    logout() {
      this.$cookies.remove("rtnVal");
      this.$cookies.remove("loginName");
      this.$router.push("/");
      localStorage.removeItem('sname');
      sessionStorage.removeItem('islog');
      location.reload();
    },
  },
  mounted() {
    if(this.$cookie){
      this.userId = this.$cookies.get("rtnVal");
      this.loginName = this.$cookies.get("loginName");
    }
  },
};
</script>
 
<style lang="less" scoped>
.index {
  width: 100%;
  height: 219px;
  background: url("../assets/images/index/top-back.png") 100% no-repeat;
  background-size: 100% 100%;
}
.top-box-logo {
  width: 488px;
  height: 75px;
  // background: url("../assets/images/index/logo.png") 100% no-repeat;
}

.logo {
  display: block;
  margin: 10px 10px 0 20px;
  width: 60px;
  height: 60px;
}

.top {
  padding: 30px 0;
}

.top-right {
  text-align: right;
  padding-top: 20px;
}

.logoHos {
  line-height: 70px;
  font-size: 40px;
  font-family: "\6977\4F53";
  font-weight: 400;
}

.index .container .login {
  width: 100px;
  height: 40px;
  color: #fff;
  background-color: #bf232c;
}
</style>
<style scoped>
.nav {
  text-align: center;
}

.el-menu {
  background-color: transparent;
}

.el-menu.el-menu--horizontal {
  border-bottom: none;
}
.el-menu-item.is-active {
  font-weight: bold;
  border-bottom: none !important;
}

.el-menu-item.is-active::after {
  content: "";
  position: absolute;
  width: 40px;
  height: 4px;
  background-color: #c0232b;
  bottom: -6px;
  left: 50%;
  transform: translateX(-50%);
}
.el-menu--horizontal .el-menu-item:not(.is-disabled):focus,
.el-menu--horizontal .el-menu-item:not(.is-disabled):hover {
  background: transparent;
}
.el-menu--horizontal > .el-menu-item {
  width: 170px;
  height: 40px;
  line-height: 40px;
  color: #fff;
  font-size: 16px;
  border: none;
}

.el-menu-item:not(:last-child)::before {
  content: "";
  position: absolute;
  width: 1px;
  height: 18px;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  background-color: #cccccc;
}

.top-container {
  width: 1200px !important;
  margin: 0 auto !important;
}
</style>



// WEBPACK FOOTER //
// src/components/top.vue